import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { Mail } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Button, Card } from "./ui";
import { intlLocale } from "@/lib/i18n";

/** Hauptschalter: Mails an Endkunden im Namen der Händler (erst nach Test und Ankündigung einschalten) */
export function EndCustomerMailCard() {
  const qc = useQueryClient();
  const q = useQuery({ queryKey: ["admin-end-customer-mail"], queryFn: api.admin.endCustomerMail });
  const set = useMutation({
    mutationFn: (enabled: boolean) => api.admin.setEndCustomerMail(enabled),
    onSuccess: (r) => { toast.success(r.enabled ? "Mails an Endkunden eingeschaltet" : "Mails an Endkunden ausgeschaltet"); void qc.invalidateQueries({ queryKey: ["admin-end-customer-mail"] }); },
    onError: () => toast.error("Konnte nicht gespeichert werden"),
  });
  if (!q.data) return null;
  const on = q.data.enabled;
  return (
    <Card className="mt-4 p-4 flex flex-wrap items-center gap-3">
      <Mail className="size-4 text-fg-subtle" />
      <div className="min-w-0 flex-1 basis-72">
        <p className="font-medium text-[13.5px]">Mails an Endkunden (Kundenkommunikation): {on ? <span className="text-success">eingeschaltet</span> : <span className="text-fg-muted">aus</span>}</p>
        <p className="text-[12.5px] text-fg-muted">
          {on
            ? `Seit ${q.data.updatedAt ? new Date(q.data.updatedAt).toLocaleString(intlLocale()) : "—"}: Händler mit dem Modul „Kundenkommunikation“ schicken Adressklärungen und Verzögerungshinweise an ihre Kunden.`
            : "Händler können alles einstellen und sich Testmails schicken; an Endkunden geht erst nach dem Einschalten etwas. Gemeldet wird dann, was offen ist (Adressklärung frühestens 15 Minuten nach dem Festhängen)."}
        </p>
      </div>
      <Button variant={on ? "secondary" : "primary"} loading={set.isPending} onClick={() => { if (on || confirm("Mails an Endkunden einschalten? Händler mit gebuchtem Modul schicken dann automatisch Adressklärungen und – falls eingeschaltet – Verzögerungshinweise.")) set.mutate(!on); }}>
        {on ? "Ausschalten" : "Einschalten"}
      </Button>
    </Card>
  );
}
